// extracted by mini-css-extract-plugin
module.exports = {"stickyStrip":"_1egPhiv3SLiDrtbXfYyv5s"};